// extracted by mini-css-extract-plugin
module.exports = {"no_screen_wrapper":"styles_no_screen_wrapper__3iZTC"};